import PropTypes from "prop-types";
import CheckboxItem from "../selection_controls/CheckboxItem";
import RadioButtonItem from "../selection_controls/RadioButtonItem";
import { isNull, isUndefined } from "underscore";

export default function Cell({
  align = "middle",
  className,
  children,
  cellData,
  header = false,
  headerData,
  id,
  justify = "start",
  minWidth,
  onClick,
  size = "medium",
  style,
  width,
}) {
  const classNames = ["lds-table-cell-" + size];
  if (header) {
    classNames.push("lds-table-headerCell", "lds-table-headerCell-" + size);
  }

  const containerStyles = { minWidth, width };
  const inlineStyles = {}
  if (align) {
    containerStyles.verticalAlign = align;
  }

  if (justify) {
    inlineStyles.justifyContent = justify
  }

  let childrenToRender = children;
  if (isUndefined(childrenToRender) || isNull(childrenToRender)) {
    childrenToRender = cellData?.getValue() || headerData?.id
  }

  // When a selection control is given, we need to have
  // reduced padding as per the design docs:
  // https://experience.lumerate.com/latest/components/table/design-specs-bpXBBWMR#section-adjustments-for-checkboxes-and-radio-buttons-1d
  if ([CheckboxItem, RadioButtonItem].includes(childrenToRender?.type)) {
    classNames.push("lds-table-cell-reduced-padding-for-selection-control")
  }

  if (onClick) {
    classNames.push("cursor-pointer")
  }

  classNames.push(className);

  return (
    <td role="cell" className="lds-table-cell-container" style={containerStyles}>
      <div
        data-testid={id}
        style={{...style, ...inlineStyles}}
        id={id}
        className={classNames.join(" ")}
        onClick={onClick}
      >
        {childrenToRender}
      </div>
    </td>
  );
}

Cell.propTypes = {
  align: PropTypes.oneOf(["top", "middle", "bottom"]),
  className: PropTypes.string,
  children: PropTypes.any,
  cellData: PropTypes.object,
  headerData: PropTypes.object,
  id: PropTypes.string,
  justify: PropTypes.oneOf(["start", "center", "end"]),
  onClick: PropTypes.func,
  size: PropTypes.oneOf(["small", "medium"]),
  style: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
